module.exports = __webpack_public_path__ + "static/media/galerija_2017 (7).aeb7af69.jpg";